"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _BackWizardButton = require("./BackWizardButton");

var _default = _BackWizardButton.BackWizardButton;
exports["default"] = _default;